import axios, { AxiosInstance } from 'axios'
import { useAuthStore } from '@/stores/auth'

const API_BASE_URL = '/api'

export const ApiClient = async (authenticated = false): Promise<AxiosInstance> => {
  if (authenticated === true) {
    const headers: Record<string, string> = {}
    const authStore = useAuthStore()
    if (authStore.isAuthenticated) {
      await authStore.refreshToken()
      headers.Authorization = `Bearer ${authStore.jwt}`
    }
    const instance = axios.create({
      baseURL: API_BASE_URL,
      headers
    })

    // // Forbidden Interceptor
    // instance.interceptors.response.use(
    //   response => response,
    //   err => {
    //     switch (err.response && err.response.status) {
    //       case 401:
    //         authStore.logout()
    //         break
    //       case 403:
    //         authStore.logout()
    //         break
    //       default:
    //         throw err
    //     }
    //   }
    // )

    return instance
  }

  return axios.create({ baseURL: API_BASE_URL })
}

export const UploadClient = () => axios.create()
